<template>
  <div allow="autoplay">
    <video-player :videoId="videoId" :permalink="permalink" />
  </div>
</template>

<script type="text/javascript">
import VideoPlayer from '@groovepages/gd-ui-kit/components/video-player/video.vue';

require('videojs-youtube');

export default {
  components: {
    VideoPlayer,
  },
  layout: 'basic',
  data() {
    return {
      videoId: this.$route.params.id,
      permalink: this.$route.params.permalink,
    };
  },
};
</script>